import React from 'react';
import ClientQuestionsModule from '../../containers/ClientQuestionsModule';

const ClientQuestionsPage = props => <ClientQuestionsModule {...props} />;

export default ClientQuestionsPage;
